import React, { useMemo } from "react";
import { useFeatureIsOn } from "@growthbook/growthbook-react";

import Badge from "ui/Badge/Badge";
import UIPrice from "ui/Price/Price";
import ZCBonuses from "assets/icons/zc-bonuses.svg";

import { formattedMoney } from "helpers/money";
import { pluralize } from "helpers/text";
import { cn } from "helpers/style";
import { EX_NEW_PRICE_PREFIX } from "constants/variables";
import styles from "./Price.module.scss";

type Props = {
  priceTypeID?: number | string;
  price: number;
  priceOld?: number | string;
  discount?: number | string;
  hasOnlyBookingPrices?: boolean;
  hasPrefix?: boolean;
  withoutPrefix?: boolean;
  prefix?: string;
  bonuses?: boolean;
  small?: boolean;
  smallBonuses?: boolean;
  className?: string;
  classNamePrice?: string;
  classNamePriceUpper?: string;
  classNamePrefix?: string;
  classNameBonuses?: string;
  // TODO: can be removed after solving the problem with the assembly of styles module.scss
  isNewPriceStyle?: boolean;
};

const Price: React.FC<Props> = ({
  price,
  priceOld,
  discount,
  hasOnlyBookingPrices,
  hasPrefix,
  withoutPrefix,
  prefix,
  bonuses,
  small = false,
  smallBonuses = false,
  className,
  classNamePrice,
  classNamePriceUpper,
  classNamePrefix,
  classNameBonuses,
  isNewPriceStyle,
}) => {
  const exNewPricePrefix = useFeatureIsOn("ex_new_priceprefix");

  const currentPrefix = (): string => {
    if (prefix && exNewPricePrefix && prefix === EX_NEW_PRICE_PREFIX) {
      return hasPrefix ? prefix + " от" : prefix;
    }

    if (prefix) return prefix;

    if (hasPrefix) return "от";

    return;
  };

  const bonusesCount = useMemo(() => {
    return Math.floor(price / 100);
  }, [price]);
  return (
    <div className={cn([styles.commonPrice, small && styles.small, className])}>
      {(priceOld !== 0 || discount > 0 || bonuses) && (
        <div className={styles.commonPriceUpper}>
          {priceOld > 0 && (
            <UIPrice
              className={cn([
                styles.commonPriceCurrencyUpper,
                classNamePriceUpper,
              ])}
              value={priceOld}
              withoutPrefix
            />
          )}
          {discount > 0 && (
            <Badge
              className={styles.commonPriceBadge}
              color="blue"
            >{`-${formattedMoney(discount)} ₽`}</Badge>
          )}
        </div>
      )}

      {price !== 0 ? (
        <UIPrice
          className={cn([
            styles.commonPriceCurrency,
            small && styles.small,
            classNamePrice,
          ])}
          isNewPriceStyle={isNewPriceStyle}
          value={price}
          withoutPrefix={withoutPrefix}
          prefix={currentPrefix()}
          classNamePrefix={classNamePrefix}
        />
      ) : (
        <b className={styles.commonPriceNotAvailable}>Нет в наличии</b>
      )}
      {bonuses && !hasOnlyBookingPrices && bonusesCount > 0 && (
        <div className={cn([styles.commonPriceBonuses, classNameBonuses])}>
          {` +${bonusesCount} ${
            smallBonuses
              ? ""
              : pluralize(bonusesCount, "балл", "балла", "баллов")
          }`}
          <ZCBonuses />
        </div>
      )}
    </div>
  );
};

export default Price;
